import { render, staticRenderFns } from "./ed-deck-card.component.vue?vue&type=template&id=09ee9602&scoped=true&"
import script from "./ed-deck-card.component.ts?vue&type=script&lang=ts&"
export * from "./ed-deck-card.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-deck-card.component.scss?vue&type=style&index=0&id=09ee9602&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ee9602",
  null
  
)

export default component.exports